import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

export function supports(query) {
    return query === "us_bank_account"
}

class Bank extends React.Component {

    constructor(props) {
        super(props);        
    }

    render() {
        return <></>
        /*
        return <>
            {this.props.data?.map((item, index) => {
                return (
                    <Card key={`line_idx_${index}`} {...item} onChange={(e) => { this.onLineChange(e, index); } } />
                );
            })}
        </>
        */
    }
}
    
Bank.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(Bank);